var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63636 21.5833C4.50909 21.5833 4.38182 21.5197 4.31818 21.4561C4.25455 21.4561 4.25455 21.3924 4.19091 21.3288C4.06364 21.2652 4 21.1379 4 20.947V8.21971C4 7.83789 4.25455 7.58334 4.63636 7.58334H8.45455C8.64545 7.58334 8.77273 7.64698 8.9 7.77425L9.98182 8.85607H19.9091C20.2909 8.85607 20.5455 9.11062 20.5455 9.49243V11.4015H22.4545C22.6455 11.4015 22.8364 11.4652 22.9636 11.6561C23.0909 11.7833 23.0909 12.0379 23.0909 12.2288L20.5455 21.1379C20.4818 21.3924 20.2273 21.5833 19.9091 21.5833H4.63636ZM5.52727 20.3106H19.4L21.5636 12.6743H8.2L5.52727 20.3106ZM5.27273 8.85607V17.2561L7.24545 11.7833C7.30909 11.5288 7.56364 11.3379 7.81818 11.3379H19.2727V10.0652H9.72727C9.53636 10.0652 9.40909 10.0015 9.28182 9.87425L8.2 8.85607H5.27273Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFolder);
export default __webpack_public_path__ + "static/media/open-folder.6ce391d8d7c9ee5f46aa2328bee6766c.svg";
export { ForwardRef as ReactComponent };